import CryptoJS from 'crypto-js';
const Decimal = require('decimal.js');
export function numToK(value, max = 9, min = 0) {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
    });
    return noExponents(formatter.format(value));
}
export const noExponents = (exponent) => {
    const data = String(exponent).split(/[eE]/);
    if (data.length === 1) return data[0];
    let z = '', sign = exponent < 0 ? '-' : '',
        str = data[0].replace('.', ''),
        mag = Number(data[1]) + 1;
    if (mag < 0) {
        z = sign + '0.';
        while (mag++) z += '0';
        return z + str.replace(/^-/, '');
    }
    mag -= str.length;
    while (mag--) z += '0';
    return str + z;
};

export function int2hex(num, width) {
    /* 转换 */
    var hex = '0123456789abcdef'
    var s = ''
    while (num) {
        s = hex.charAt(num % 16) + s; num = Math.floor(num / 16)
    }
    if (typeof width === 'undefined' || width <= s.length) {
        return '0x' + s
    }
    var delta = width - s.length
    var padding = ''
    while (delta-- > 0) {
        padding += '0'
    }
    return '0x' + padding + s
}

export function idComplex(id, length) {
    return CryptoJS.MD5(id).toString().slice(0, length) + '00' + id;
}

//地址是否相同
export function isSameAddress(address1, address2) {
    return address1 === address2 || String(address1).toLowerCase() === String(address2).toLowerCase();
}
export function handleAddress(address, start = 6, end = 4) {
    return address.slice(0, start) + "..." + address.slice(-end);
}
export function handleTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
    //转为YYYY-MM-DD HH:mm:ss
    let date = new Date(time * 1000);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let h = date.getHours();
    let i = date.getMinutes();
    let s = date.getSeconds();

    if (M < 10) {
        M = '0' + M
    }
    if (D < 10) {
        D = '0' + D
    }
    if (h < 10) {
        h = '0' + h
    }
    if (i < 10) {
        i = '0' + i
    }
    if (s < 10) {
        s = '0' + s
    }
    return Y + '-' + M + '-' + D + ' ' + h + ':' + i + ':' + s;
}

export function formatTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!time) return '';

    time += '000';
    // 如果 time 是时间戳，确保转换为数字并处理可能的秒级/毫秒级差异
    if (typeof time === 'string' || typeof time === 'number') {
        time = new Date(Number(time));
        if (isNaN(time.getTime())) {
            return ''; // 无效时间戳
        }
    }

    // 确保 time 是有效的 Date 对象
    if (!(time instanceof Date) || isNaN(time.getTime())) {
        return '';
    }

    // 定义替换规则
    const map = {
        'YYYY': time.getFullYear(),
        'MM': String(time.getMonth() + 1).padStart(2, '0'),
        'DD': String(time.getDate()).padStart(2, '0'),
        'HH': String(time.getHours()).padStart(2, '0'),
        'mm': String(time.getMinutes()).padStart(2, '0'),
        'ss': String(time.getSeconds()).padStart(2, '0')
    };

    // 替换格式中的占位符
    return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => map[match]);
}


//睡眠
export function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

//计算器 加：add 减：sub 乘：mul 除：div
export function computer(value1, value2, op = 'add') {
    return new Decimal(value1)[op](value2);
}
//两个wei相加
export function addWei(num1, num2) {
    return num1.add(num2);
}

// 处理API响应消息，优先使用msg_code进行多语言显示
export function handleApiMessage(response, i18n) {
    if (response && response.msg_code && i18n) {
        return i18n.t(response.msg_code);
    }
    return response ? response.msg : '';
}

// 智能返回函数
export function smartGoBack(vm, fallbackRoute = '/') {
    const router = vm.$router;
    const route = vm.$route;

    // 检查是否有来源页面信息
    if (route.query.from) {
        // 根据来源页面决定返回路径
        switch (route.query.from) {
            case 'order':
                router.push({ name: 'order' });
                return;
            case 'order-list':
                router.push({ name: 'order-list' });
                return;
            case 'home':
            case 'index':
                router.push({ name: 'index' });
                return;
            case 'my':
                router.push({ name: 'my' });
                return;
            case 'shop':
                router.push({ name: 'index', query: { tab: 'shop' } });
                return;
            case 'detail':
                // 从详情页进入的，需要恢复详情页的参数
                if (route.query.detailId && route.query.detailType) {
                    router.push({
                        name: 'detail',  // 统一使用detail路由名称
                        params: {
                            id: route.query.detailId,
                            type: route.query.detailType
                        }
                    });
                } else {
                    // 如果没有详情页参数，返回首页
                    router.push({ name: 'index' });
                }
                return;
            case 'code':
                // 从扫码页进入的，返回首页
                router.push({ name: 'index' });
                return;
            default:
                // 尝试根据from参数跳转到对应页面
                try {
                    router.push({ name: route.query.from });
                } catch (error) {
                    console.warn('无法跳转到指定页面:', route.query.from, error);
                    router.push(fallbackRoute);
                }
                return;
        }
    }

    // 检查路由历史长度
    if (window.history.length > 1) {
        // 有历史记录，使用浏览器返回
        router.go(-1);
    } else {
        // 没有历史记录，返回默认页面
        router.push(fallbackRoute);
    }
}

// 页面返回配置映射
export const pageBackConfig = {
    'order-detail': { from: 'order-list', fallback: '/order-list' },
    'order-delivery': { from: 'order-detail', fallback: '/order-list' },
    'payment': { from: 'order', fallback: '/order' },
    'payment-result': { from: 'order-list', fallback: '/order-list' },
    'productDetail': { from: 'index', fallback: '/' },
    'package-detail': { from: 'index', fallback: '/' },
    'package-purchase': { from: 'package-detail', fallback: '/' },
    'address': { from: 'my', fallback: '/my' },
    'address-add': { from: 'address', fallback: '/address' },
    'search': { from: 'index', fallback: '/' },
    'detail': { from: 'index', fallback: '/' },
    'detailWithId': { from: 'index', fallback: '/' },
    'recharge': { from: 'my', fallback: '/my' },
    'shopCart': { from: 'index', fallback: '/' },
    'login': { from: 'my', fallback: '/my' },
    'register': { from: 'login', fallback: '/login' }
};